import React, { useState } from "react";
import "./navbar.css";
import { RiCloseLine, RiMenu3Line } from "react-icons/ri";
import { Link } from "react-router";
import navLogo from "../../Media/zakarry-logo-black.png"

export default function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div>
      <div className="navbar">
        <div className="navbar-left">
          <Link to="/">
            <img
              src={navLogo}
              className="logo"
              alt="Logo"
            />
          </Link>
        </div>

        <div className="navbar-right">
          <ul>
            <li>
              <Link to="/shop">SHOP</Link>
            </li>
            <li>
              <Link to="/about">ABOUT</Link>
            </li>
            <li>
              <Link to="/contact">CONTACT</Link>
            </li>
            <li>
              <Link to="">PAGES</Link>
              <ul className="dropdown">
                <li>
                  <Link to="/gallary">GALLARY</Link>
                </li>
                <li>
                  <Link to="/services">SERVICES</Link>
                </li>
              </ul>
            </li>
          </ul>

          <Link to="/booking">
            <button className="nav-button">BOOK APPOINTMENT</button>
          </Link>
        </div>

        <div className="navbar-menu">
          {toggleMenu ? (
            <RiCloseLine onClick={() => setToggleMenu(false)} />
          ) : (
            <RiMenu3Line onClick={() => setToggleMenu(true)} />
          )}
          {toggleMenu && (
            <div className="navbar-menu-container scale-up-center">
              <Link to="/contact">CONTACT</Link>
              <Link to="/gallary">GALLARY</Link>
              <Link to="/services">SERVICES</Link>
              <Link to="/shop">SHOP</Link>
              <Link to="/booking">
                <button className="nav-button">BOOK APPOINTMENT</button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
